<script>
  import {getContext} from 'svelte';
  import Page from '@/modules/components/Page.svelte';
  import Header from '@/modules/header/Header.svelte';
  import {TRADING_GAME} from './images';
  import {myEntryInfo$} from './stream';
  import Footer from './components/Footer.svelte';
  import Banner from './components/Banner.svelte';
  import GameInfo from './components/GameInfo.svelte';
  import PrizeStructure from './components/PrizeStructure.svelte';
  import ScheduleRules from './components/ScheduleRules.svelte';
  import EntryInformation from './components/EntryInformation.svelte';
  import Rankings from './components/Rankings.svelte';
  import lang from './TradeCompetitionPage.lang';

  const LG = getContext('LG');
</script>

<style>
  .competition-page {
    background: #010612;
  }
  .page-section {
    padding-top: 80px;
  }
  .page-section-title {
    padding-bottom: 40px;
    text-align: center;
    font-size: 32px;
    font-weight: bold;
    color: #fff;
  }
  @media screen and (min-width: 640px) {
    .page-content {
      margin: 0 auto;
      width: 1200px;
    }
    .competition-page {
      min-width: 1200px;
    }
  }
  @media screen and (max-width: 640px) {
    .page-content {
      padding: 0 4%;
      width: 92%;
      overflow: hidden;
    }
    .page-section {
      padding-top: 50px;
    }
    .competition-page {
      width: 100%;
    }
    .page-section-title {
      padding-bottom: 20px;
      font-size: 16px;
    }
  }
</style>

<svelte:head>
  <title>{LG(lang.Title)}</title>
  <meta name="description" content={LG(lang.Description)} />
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:site" content="@Phemex_official" />
  <meta name="twitter:title" content={LG(lang.Title)} />
  <meta name="twitter:image" content={TRADING_GAME.SHARE} />
  <meta name="og:title" content={LG(lang.Title)} />
  <meta name="og:description" content={LG(lang.Description)} />
  <meta name="og:image" content={TRADING_GAME.SHARE} />
</svelte:head>

<Page customTwitter customOpenGraph>
  <div class="competition-page">
    <Header />
    <Banner />
    <div class="page-content">
      <GameInfo />
      {#if $myEntryInfo$.isJoinedCompetition}
        <div class="page-section">
          <div class="page-section-title">{LG(lang.MyEntryInformation)}</div>
          <EntryInformation />
        </div>
      {/if}
      <Rankings />
      <div class="page-section">
        <div class="page-section-title">{LG(lang.CompetitionPrizeStructure)}</div>
        <PrizeStructure />
      </div>
      <div class="page-section">
        <div class="page-section-title">{LG(lang.ActivityScheduleAndRules)}</div>
        <ScheduleRules />
      </div>
    </div>
    <Footer />
  </div>
</Page>
